/**
 * 프로필 API 서비스
 */

import apiClient from '../../core/http/axios';

export interface StudentProfile {
  user_no: number;
  id?: string;
  name: string;
  email: string | null;
  tel: string | null;
  student_number: string;
  university: string;
  university_no: number;
  department: string;
  department_no: number;
}

export interface StudentProfileResponse {
  success: boolean;
  error: string | null;
  data: StudentProfile;
  code: string | null;
  meta: {
    elapsed_ms: number;
  };
}

export interface UpdateStudentProfileRequest {
  name?: string;
  tel?: string;
  email?: string;
  university_no?: number;
  department_no?: number;
  student_number?: string;
  password?: string;
  password_confirm?: string;
}

/**
 * 학생 프로필 조회
 */
export const getStudentProfile = async (): Promise<StudentProfile> => {
  const response = await apiClient.get<StudentProfileResponse>('/auth/student/me');
  return response.data.data;
};

/**
 * 학생 프로필 수정
 * API 스펙: name, tel, email, university_no, department_no, student_number, password, password_confirm
 */
export const updateStudentProfile = async (
  data: UpdateStudentProfileRequest
): Promise<StudentProfile> => {
  const payload: Record<string, string | number> = {
    name: data.name ?? '',
    tel: data.tel ?? '',
    university_no: data.university_no ?? 0,
    department_no: data.department_no ?? 0,
    student_number: data.student_number ?? '',
  };
  if (data.email !== undefined) payload.email = data.email;
  if (data.password) payload.password = data.password;
  if (data.password_confirm) payload.password_confirm = data.password_confirm;

  const response = await apiClient.put<StudentProfileResponse>('/auth/student/me', payload);
  return response.data.data;
};
